var _path, _path2, _path3, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCubo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 57,
    viewBox: "0 0 55 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 21.3008L26.9356 26.3005V40.9997L16 36V21.3008Z",
    fill: "#313335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1588 16L38.2618 20.8497L27.1588 25.8995L16 20.8497L27.1588 16Z",
    fill: "#96999C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3184 21.3008L27.3827 26.3005V40.9997L38.3184 36V21.3008Z",
    fill: "#636769"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 53.319,
    height: 56,
    rx: 7.5,
    stroke: "#313335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubo);
export default __webpack_public_path__ + "static/media/cubo.cd97cc91d979626f1bd851202d877681.svg";
export { ForwardRef as ReactComponent };